import { cx } from '@linaria/core';
import { TransitionGroup } from 'react-transition-group';
import { Link } from '@provider/navigation';
import { resets } from '@ui/css';
import { withSlots, CSSRefTransition } from '@utils/react';
import { icon, iconFadeDurationMs, checkmark, wrapper } from './fab.style.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { CheckmarkIcon } from '../../icons/checkmark.js';
import { Tooltip } from '../overlays/tooltip/tooltip.js';

const FloatingActionButton = withSlots(function FloatingActionButton({
  as,
  tooltip,
  slots,
  state,
  ...props
}) {
  const icons = slots.findAll("Icon");
  const content = ref => {
    const Comp = as === "a" ? Link : "button";
    return /*#__PURE__*/jsxs(Comp, {
      ...props,
      // @ts-expect-error We allow our button ref to contain a generic
      // HTMLElement.
      ref: ref,
      className: cx(resets.rootCls, props.className, wrapper),
      "data-state": state,
      children: [/*#__PURE__*/jsx(TransitionGroup, {
        component: null,
        children: icons.filter(icon => typeof icon.active === "undefined" || icon.active).map((icon$1, index) => /*#__PURE__*/jsx(CSSRefTransition, {
          timeout: iconFadeDurationMs,
          classNames: icon,
          children: ref => /*#__PURE__*/jsx("span", {
            className: cx(icon, !icon$1.disableScaleDuringTransition && "enableScaling"),
            ref: ref,
            children: icon$1.children
          })
        }, icon$1.contentKey ?? index))
      }), (state === "success" || state === "partial-success") && /*#__PURE__*/jsx("span", {
        className: checkmark,
        "data-state": state,
        children: /*#__PURE__*/jsx(CheckmarkIcon, {
          height: 7,
          strokeWidth: 3
        })
      })]
    });
  };
  if (tooltip) {
    return /*#__PURE__*/jsx(Tooltip, {
      ...tooltip,
      containerRef: props.ref,
      children: ref => content(ref)
    });
  }
  return content();
});

export { FloatingActionButton };
//# sourceMappingURL=fab.js.map
